/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChargebackBatchCreate, ChargebackBatchDetails, ChargebackBatchExport, ChargebackBatchUpdate, PagedItems, PagingQuery } from './V2/gozer';
import { request as __requestG } from './V2/gozer/core/request';

export class ChargebacksService {

    /**
     * @param requestBody
     * @param operatorId
     * @returns ChargebackBatchDetails
     * @throws ApiError
     */
    public static async chargebacksVCreateBatch(
        requestBody: Array<ChargebackBatchCreate>,
        operatorId?: string | null,
    ): Promise<ChargebackBatchDetails> {
        const result = await __requestG({
            method: 'POST',
            path: `/GozerApi/api/v2/chargebacks/batch`,
            query: {
                'operatorId': operatorId,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param chargebackId
     * @param pageNumber
     * @returns ChargebackBatchDetails
     * @throws ApiError
     */
    public static async chargebacksVGetBatch(
        chargebackId: string,
        pageNumber?: number,
    ): Promise<ChargebackBatchDetails> {
        const result = await __requestG({
            method: 'GET',
            path: `/GozerApi/api/v2/chargebacks/batch/${chargebackId}`,
            query: {
                'pageNumber': pageNumber,
            },
        });
        return result.body;
    }

    /**
     * @param chargebackId
     * @param requestBody
     * @returns ChargebackBatchDetails
     * @throws ApiError
     */
    public static async chargebacksVUpdateBatch(
        chargebackId: string,
        requestBody: Array<ChargebackBatchUpdate>,
    ): Promise<ChargebackBatchDetails> {
        const result = await __requestG({
            method: 'PATCH',
            path: `/GozerApi/api/v2/chargebacks/batch/${chargebackId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param chargebackId
     * @returns ChargebackBatchExport
     * @throws ApiError
     */
    public static async chargebacksVGetExportForBatch(
        chargebackId: string,
    ): Promise<Array<ChargebackBatchExport>> {
        const result = await __requestG({
            method: 'GET',
            path: `/GozerApi/api/v2/chargebacks/batch/${chargebackId}/export`,
        });
        return result.body;
    }

    /**
     * @param chargebackId
     * @returns any
     * @throws ApiError
     */
    public static async chargebacksVCancelBatch(
        chargebackId: string,
    ): Promise<any> {
        const result = await __requestG({
            method: 'DELETE',
            path: `/GozerApi/api/v2/chargebacks/batch/${chargebackId}/cancel`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns PagedItems
     * @throws ApiError
     */
    public static async chargebacksVGetAll(
        requestBody: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __requestG({
            method: 'POST',
            path: `/GozerApi/api/v2/chargebacks/get`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param chargebackId
     * @returns any
     * @throws ApiError
     */
    public static async chargebacksVPostAutoPay(
        chargebackId: string,
    ): Promise<any> {
        const result = await __requestG({
            method: 'POST',
            path: `/CharonApi/api/v2/chargebacks/${chargebackId}/run`,
        });
        return result.body;
    }

}